import request from '@/utils/request';
// const token = "cjhobk16v8jse9u0o2mudlbc7i"
var url = location.search;
if (url.indexOf("?") != -1) {  
  var strs = url.substr(1).split("&")[0].split("=")[1];   
  var appId = url.substr(1).split("&")[1].split("=")[1];
}  
const getApiPath = () => {
    const urlParams = new URLSearchParams(window.location.search);
    // 将 URLSearchParams 转换为对象
    const params = Object.fromEntries(urlParams.entries());

    const apiPath = !params['SHOP_ID'] || params['SHOP_ID'] == 0?'store':'storeAdmin'

    return apiPath
}

const apiPath = getApiPath()


export const getList = ({page, search, category_id}) => {
    return request.get(`/${apiPath}/goods_price/lists?TOKEN_SESSION=${strs}&wxapp_id=${appId}`, {
       params: {
            page,
            size: 30,
            search,
            category_id,
        } 
    })
}

export const updateList = (arr) => {
    return request.post(`/${apiPath}/goods_price/update?TOKEN_SESSION=${strs}`,  arr)
}

export const categoryList = () => {
    return request.get(`/${apiPath}/goods_price/category?wxapp_id=${appId}&&TOKEN_SESSION=${strs}`)
}
